import React, { Component } from "react";
import styles from "./Info.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo, faTimes } from "@fortawesome/free-solid-svg-icons";


export default class Info extends Component {
  constructor(props) {
      super(props);
      this.state = {
        extend: false
      };
  }

  render() {
    return (
      <div className={styles.InfoBox}>

        {!this.state.extend &&
          <div
          className={styles.InfoIcon}
          onClick={() => this.setState({extend: true})}>
            <FontAwesomeIcon
              icon={faInfo}
            />
          </div>
        }

        {this.state.extend &&
          <div className={styles.ShowInfo}>
            <div className={styles.CloseBox}>

              <FontAwesomeIcon
                onClick={() => this.setState({extend: false})}
                className={styles.CloseIcon}
                icon={faTimes}
              />

            </div>

            <p>The data found on this page is sourced from
              <a rel="noopener noreferrer" target="_blank" href="https://211ontario.ca/">{" 211 Ontario "}</a>
              and
              <a rel="noopener noreferrer" target="_blank" href="https://opendatakingston.cityofkingston.ca">{" Kingston's Open Data Portal"}</a>
            </p>
          </div>
        }

      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/Map/Info/Info.js